import { useEffect, useRef, useState } from 'react';

export default function ShareBar({ title }: { title: string }) {
  const [open, setOpen] = useState(false);
  const [toast, setToast] = useState('');
  const wrapRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!open) return undefined;
    const handler = (event: MouseEvent) => {
      if (wrapRef.current && !wrapRef.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  useEffect(() => {
    if (!toast) return undefined;
    const timer = setTimeout(() => setToast(''), 2200);
    return () => clearTimeout(timer);
  }, [toast]);

  const shareUrl = typeof window !== 'undefined' ? window.location.href : '';

  const copyLink = async () => {
    try {
      await navigator.clipboard.writeText(shareUrl);
      setToast('链接已复制到剪贴板');
    } catch {
      setToast('复制失败，请手动复制地址栏链接');
    }
    setOpen(false);
  };

  const social = [
    {
      label: '微博',
      icon: 'ri-weibo-fill',
      href: `https://service.weibo.com/share/share.php?url=${encodeURIComponent(shareUrl)}&title=${encodeURIComponent(title)}`,
    },
    {
      label: 'QQ空间',
      icon: 'ri-qq-fill',
      href: `https://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?url=${encodeURIComponent(shareUrl)}&title=${encodeURIComponent(title)}`,
    },
    {
      label: '豆瓣',
      icon: 'ri-douban-fill',
      href: `https://www.douban.com/share/service?href=${encodeURIComponent(shareUrl)}&name=${encodeURIComponent(title)}`,
    },
  ];

  return (
    <div className="relative" ref={wrapRef}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
      >
        <i className="ri-share-forward-line"></i>
        分享
      </button>

      {open && (
        <div className="absolute right-0 top-12 z-20 w-56 rounded-lg border border-background-200 bg-background-50 p-2 shadow-xl animate-fade-in">
          <button
            type="button"
            onClick={copyLink}
            className="flex w-full items-center gap-2 rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100"
          >
            <i className="ri-link text-base text-primary-600"></i>
            复制链接
          </button>
          <div className="my-1 h-px bg-background-200"></div>
          {social.map((item) => (
            <a
              key={item.label}
              href={item.href}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setOpen(false)}
              className="flex w-full items-center gap-2 rounded-md px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100"
            >
              <i className={`${item.icon} text-base text-accent-500`}></i>
              分享到{item.label}
            </a>
          ))}
          <p className="px-3 pb-1 pt-2 text-[11px] leading-relaxed text-foreground-400">
            演示环境：分享仅为前端演示，链接指向当前页面。
          </p>
        </div>
      )}

      {toast && (
        <div className="fixed bottom-8 left-1/2 z-[70] -translate-x-1/2 rounded-md bg-foreground-950 px-4 py-2 text-sm text-background-50 shadow-lg animate-fade-up">
          {toast}
        </div>
      )}
    </div>
  );
}